import React, { useEffect, useState } from 'react';
import { includes, isEmpty, isNil } from '@libs/shared';
import { platformIntl } from '../../constants';
import { getRoleCardDetail } from '../../apis';
import { RoleType } from '../../interfaces';
import { authModel } from '../../models';

interface RoleCardProps {
    roleId: string;
}

/**
 * 角色信息卡片
 */
const RoleCard: React.FC<RoleCardProps> = ({ roleId }) => {
    // '' 展示无法查看角色信息的提示
    const [viewInfo, setViewInfo] = useState<string>();

    useEffect(() => {
        fetchRoleInfo();
    }, []);

    const fetchRoleInfo = () => {
        getRoleCardDetail(roleId, authModel.tenantId)
            .then((data) => {
                if (includes([RoleType.corp_coop, RoleType.external], data.role.type)) {
                    return;
                }
                setViewInfo(data.role_group.name);
            })
            .catch(() => {
                setViewInfo('');
            });
    };

    const renderRoleInfo = () => {
        if (isEmpty(viewInfo)) {
            return (
                <div className="popover-content-empty">{platformIntl.get('role.empty.tip')}</div>
            );
        }

        return (
            <div className="popover-content">
                <div className="content-info">
                    <div className="info-item">
                        <div className="item-label">{platformIntl.get('role.belong')}:</div>
                        <div className="item-info">{viewInfo}</div>
                    </div>
                </div>
            </div>
        );
    };

    if (isNil(viewInfo)) {
        return null;
    }

    return <div className="fx-role-card">{renderRoleInfo()}</div>;
};

export default RoleCard;
